export default {"src":"/_next/static/media/AT.604eb32a.svg","height":342,"width":513,"blurWidth":0,"blurHeight":0};